import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, InitialLoading } from '@src/components/molecules';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ErrorBoundary>
    <React.Suspense fallback={<InitialLoading />}>
      <App />
    </React.Suspense>
  </ErrorBoundary>,
);
